// extracted by mini-css-extract-plugin
module.exports = {"page":"IframeSingleEvent_page__1vzq_","wrapper":"IframeSingleEvent_wrapper__24FXg","backBtn":"IframeSingleEvent_backBtn__1PcJk","hero":"IframeSingleEvent_hero__6wRMF"};